module.exports = __webpack_public_path__ + "static/img/hutomagnes_narancs.baf27aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-hutomagnes/hutomagnes_narancs.jpg
// module id = 568
// module chunks = 0